<template>
  <div class="page-table scrollable only-y mainDiv mb-30">
    <div class="card-base baslikBg animated fadeInUp">Talimat Listesi
      <div class="tanimlamaButon">
        <el-tooltip :content='$t("src.views.apps.genel.yeniKaydet")' :open-delay="500" placement="top">
          <el-button v-on:click="routeMusteri('Talimat Tanımla')" size="mini" type="text"
                     icon="el-icon-plus"></el-button>
        </el-tooltip>
        <el-tooltip :content='$t("src.views.apps.genel.refresh")' :open-delay="500" placement="top">
          <el-button v-on:click="refreshPage()" style="margin-left: 15px !important" type="text"
                     icon="el-icon-refresh"></el-button>
        </el-tooltip>
      </div>
    </div>
    <div class="page-header card-base card-shadow--medium animated fadeInUp" v-loading="loading || stateLoading"
         :element-loading-text='loading ? "Muhasebe Listesi Getiriliyor Lütfen Bekleyiniz" : "Muhasebe Durum Güncelleniyor. Lütfen Bekleyiniz."'
         element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 1)">
      <el-row class="mt-0 mb-10">
        <el-col :lg="12" :md="12" :sm="24" :xs="24">
          <div>
            <el-radio-group size="small" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9"
                            text-color="gray" :disabled="searchLoading">
              <el-radio-button label="1">
                <i class="mdi mdi-account mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                <transition name="slide-fade">
                  <label v-if="durum == '1'">Aktif Talimatlar</label>
                </transition>
              </el-radio-button>
              <el-radio-button label="0">
                <i class="mdi mdi-account mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                <transition name="slide-fade">
                  <label v-if="durum == '0'">Pasif Talimatlar</label>
                </transition>
              </el-radio-button>
            </el-radio-group>
          </div>
        </el-col>
        <br v-if="!isDesktop">
        <br v-if="!isDesktop">
        <el-col :lg="12" :md="12" :sm="24" :xs="24">
          <el-col :lg="24" :md="24" :sm="24" :xs="24">
            <ul class="islemler">
              <li>
                <i class="mdi mdi-file-document-outline mdi-18px" style="color: #86A7FC"></i>
                <span>Talimat Detay</span>
              </li>
              <!--              <li>-->
              <!--                <i class="mdi mdi-circle-edit-outline mdi-18px" style="color: #f7ba2a"></i>-->
              <!--                <span>Talimat Düzenle</span>-->
              <!--              </li>-->
              <li v-if="durum == '1'">
                <i class="mdi mdi-trash-can mdi-18px" style="color: #ec205f"></i>
                <span>Pasif Yap</span>
              </li>
              <li v-else>
                <i class="mdi mdi-play mdi-18px" style="color: #048484"></i>
                <span>Aktif Yap</span>
              </li>
            </ul>
          </el-col>
        </el-col>
      </el-row>
      <div class="my-custom-table">
        <el-table v-loading="searchLoading" border stripe :data="talimatList"
                  style="width: 100%" :element-loading-text='"Talimatlar Aranıyor. Lütfen Bekleyiniz."'
                  element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 1)">
          <el-table-column label='Dekont' align="left" width="300">
            <template slot-scope="scope">
              <div class="flex">
                <el-tooltip v-if="scope.row.dekont != '' && scope.row.dekont !== null" content='Dekontu İndir'
                            :open-delay="500" placement="bottom">
                  <el-button @click="downloadFile(scope.row);" class="download-btn" type="primary"><i
                      class="mdi mdi-download mdi-20px"></i></el-button>
                </el-tooltip>
                <el-tooltip v-if="scope.row.dekont == null" content='Dekont Yükle'
                            :open-delay="500" placement="bottom" class="upload-tooltip">
                  <el-upload class="upload"
                             :file-list="dekontListMain.findIndex(item=> item.muhasebeID == scope.row.muhasebeID) != -1 ? dekontListMain : []"
                             :id="'evrakEkle_' + scope.row.muhasebeID" action="" :auto-upload="false" :limit="1"
                             :on-change="file => evrakUpload(file, scope.row)"
                             :on-remove="evrakRemove" list-type="belge-card" accept="">

                    <el-button :loading="updateTalimatID == scope.row.muhasebeID" v-if="yetkiTuru != '3'"
                               class="upload-btn"
                               type="primary">
                      <i v-if="updateTalimatID != scope.row.muhasebeID" class="mdi mdi-cloud-upload mdi-20px"></i>
                    </el-button>
                  </el-upload>
                </el-tooltip>
              </div>
              <!--              <div class="flex">-->
              <!--                <el-upload v-show="false" v-if="scope.row.dekont != '' && scope.row.dekont !== null" class="upload"-->
              <!--                           :file-list="dekontListMain.findIndex(item=> item.muhasebeID == scope.row.muhasebeID) != -1 ? dekontListMain : []"-->
              <!--                           :id="'evrakEkle_' + scope.row.uniqueId" action="" :auto-upload="false" :limit="1"-->
              <!--                           :on-change="file => evrakUpload(file, scope.row)"-->
              <!--                           :on-remove="evrakRemove" list-type="belge-card" accept="" style="margin-left: 40px">-->
              <!--                  <el-button v-if="yetkiTuru != '3'" style="background-color: #ffba4b; border:none" size="mini"-->
              <!--                             type="warning"-->
              <!--                             icon="el-icon-upload">Dekont Değiştir-->
              <!--                  </el-button>-->
              <!--                </el-upload>-->
              <!--              </div>-->
            </template>
          </el-table-column>
          <el-table-column prop="sablonAdi" label="Şablon"/>
          <el-table-column prop="tarih" label='Tarih' width="200"/>
          <el-table-column :label='$t("src.views.apps.genel.islem")' width="240">
            <template slot-scope="scope">
              <el-tooltip content='Talimat Detay'
                          :open-delay="500" placement="bottom">
                <el-button @click="talimetDetay(scope.row)" type="text" class="islem-button"
                           style="color: #86A7FC;">
                  <i class="mdi mdi-file-document-outline mdi-24px"/>
                </el-button>
              </el-tooltip>
              <!--              <el-tooltip content='Talimat Düzenle'-->
              <!--                          :open-delay="500" placement="bottom">-->
              <!--                <el-button @click="updatePage(scope.row)" type="text" class="islem-button"-->
              <!--                           style="color: #f7ba2a; margin-left: 15px !important;"-->
              <!--                           icon="mdi mdi-circle-edit-outline mdi-24px">-->
              <!--                </el-button>-->
              <!--              </el-tooltip>-->
              <el-tooltip content='Pasif Yap' :open-delay="500"
                          v-if="durum == '1'" placement="bottom">
                <el-button @click="changeTalimatDurum(scope.row, '0')" class="buttonDel"
                           style="margin-left: 15px !important;" type="text"
                           icon="mdi mdi-trash-can mdi-24px"></el-button>
              </el-tooltip>
              <el-tooltip content='Aktif Yap' :open-delay="500"
                          v-if="durum == '0'" placement="bottom">
                <el-button @click="changeTalimatDurum(scope.row, '1')" type="text"
                           style="margin-left: 15px !important;" class="islem-button-play islem-button ml-15"
                           icon="mdi mdi-play mdi-24px"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination background layout="sizes,prev, pager, next, jumper, total" :total="total"
                     @size-change="handleSizeChange" @current-change="pageChange" :page-sizes="[20, 50, 100]"
                     :current-page.sync="page" :next-click.sync="page" :prev-click.sync="page" @next-click="pageChange"
                     @prev-click="pageChange">
      </el-pagination>
    </div>
    <el-dialog title="Talimat Detay" :visible.sync="dialogVisible" width="50%">
      <el-row class="mb-10">
        <el-col :span="24">
          <el-image @click="downloadFile(talimatData)" v-if="talimatData.dekont"
                    :src="talimatService.dekontPath+talimatData.dekont"
                    style="width: 100px; height: 100px;cursor: pointer"/>
        </el-col>
        <el-col :span="24">
          <el-upload class="upload" action="" :auto-upload="false" :limit="1" list-type="belge-card" accept=""
                     :on-change="file => evrakUpload(file, talimatData)" :on-remove="evrakRemove"
                     :file-list="dekontListMain.findIndex(item=> item.muhasebeID == talimatData.muhasebeID) != - 1 ? dekontListMain : []"
                     style="display: inline-block">
            <el-button v-if="yetkiTuru != '3'" class="upload-btn" type="primary">
              {{ !talimatData.dekont ? 'Dekont Yükle' : 'Dekontu Değiştir' }}
            </el-button>
          </el-upload>
          <el-button @click="talimatUpdateCancel" type="primary" size="small" class="mt-10"
                     :style="{backgroundColor: isTalimatUpdate ? '#FF9843' : '#39A7FF'}"
                     style="float: right;border:none">
            {{ isTalimatUpdate ? 'Vazgeç' : 'Talimatı Düzenle' }}
          </el-button>
        </el-col>
      </el-row>
      <ckeditor :disabled="!isTalimatUpdate" :editor="editor" :config="editorConfig"
                v-model="talimatData.sablon_icerik"/>
      <el-row>
        <el-col :span="24" class="justify-flex-end flex">
          <el-button v-if="isTalimatUpdate" @click="talimatUpdate" type="primary" size="small" class="mt-10"
                     style="background-color: #39A7FF;border: none;">Kaydet
          </el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import CKeditor from '@ckeditor/ckeditor5-build-classic/build/ckeditor'
import musteriService from '../../../WSProvider/MusteriService'
import EventBus from '@/components/event-bus'
import notification from '../../../notification'
import functions from '../../../functions'
import talimatService from "@/WSProvider/TalimatService";


export default {
  name: "TalimatListesi",
  computed: {
    talimatService() {
      return talimatService
    }
  },
  components: {},
  data() {
    return {
      updateTalimatID: null,
      isTalimatUpdate: false,
      dekontListMain: [],
      dekontForm: {
        evrakTarihi: "",
        durum: '1',
        cariID: "",
        evrak: [],
        evrakID: '',
        evrakAdi: ''
      },
      talimatData: [],
      editor: CKeditor,
      editorConfig: {
        language: 'tr',
      },
      dialogVisible: false,
      isDesktop: false,
      loading: false,
      stateLoading: false,
      searchLoading: false,
      //editDialogLoading: false,
      editDialog: false,
      editDialogData: {},
      talimatList: [],
      yetkiListesi: [],
      tarihler: [],
      yetkiTuru: "",
      yoneticiID: "",
      radio: '1',
      rulesMusteri: {},
      sizes: 20,
      durum: '1',
      page: 0,
      postPage: 0,
      total: 4,
      firmaAdiAra: "",
      unvanAra: "",
      adresAra: "",
      telefonAra: "",
      epostaAra: "",
    }
  },
  created() {
    this.checkDevice();
    if (localStorage.getItem("userDataDemirag")) {
      this.yetkiTuru = this.$store.getters.getYetkiTuru;
      this.yetkiListesi = this.$store.getters.getYetkiListesi;
      this.yoneticiID = this.$store.getters.getYoneticiID;
      //console.log(this.yetkiListesi)
    }
    EventBus.$on("talimatListesi", (durum) => {
      this.refreshPage(durum ? 1 : 0)
    });
  },
  mounted() {
    this.getTalimatListesi();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },
  methods: {
    talimatUpdate() {
      talimatService.talimatGuncelle(this.talimatData.sablon_icerik, this.talimatData.muhasebeID, this.talimatData.sayi, this.talimatData.tarih, this.talimatData.konu, this.talimatData.aciklama).then((response) => {
        if (response.status == 200) {
          notification.Status('success', this, response.msg);
          EventBus.$emit("talimatListesi", true)
          this.dialogVisible = false
        }
      }).catch(err => {
        if (err.responseJSON) {
          let error = err.responseJSON
          if (error.status == 401) {
            notification.Status(150, this);
          } else if (error.status == 404) {
          } else notification.Status("errorMsg", this, error.errMsg)
        }
        this.loading = false;
      }).finally(() => {
        this.talimetDetay()
        this.isTalimatUpdate = false
      })
    },
    talimatUpdateCancel() {
      if (this.isTalimatUpdate) {
        this.isTalimatUpdate = false
        this.talimetDetay()
      } else {
        this.isTalimatUpdate = true
      }
    },
    evrakUpload(file, row, formName) {
      this.$set(row, 'dosyaYuklendi', true);
      const item = {
        name: file.name,
        url: file.url,
        id: file.raw.lastModified,
        size: file.raw.size,
        muhasebeID: row.muhasebeID,
      };
      this.dekontListMain.push(item)
      file.raw["tmp_name"] = file.url;
      this.dekontForm.evrak.push(file.raw);
      this.$forceUpdate();
      //row.dosyaYuklendi = false;
      this.$confirm("Dekont Eklemek İstediğinize Emin Misiniz?", this.$t("src.views.apps.genel.uyari"), {
        confirmButtonText: this.$t("src.views.apps.genel.yes"),
        cancelButtonText: this.$t("src.views.apps.genel.no"),
        type: 'warning'
      }).then(() => {
        this.updateTalimatID = row.muhasebeID
        this.evrakLoading = true;
        talimatService.dekontEkle(row.muhasebeID, this.dekontForm.evrak[0], 'update').then((response) => {
          if (response.status == 200) {
            localStorage.setItem("userDataDemirag", response.token)
            notification.Status("success", this, response.msg)
            this.refreshPage(row.dosyaDurumu)
            this.resetForm(formName)
          }
          this.evrakLoading = false;
        }).catch(err => {
          if (err.responseJSON) {
            let error = err.responseJSON
            if (error.status == 401) {
              notification.Status(150, this);
            } else notification.Status("errorMsg", this, error.errMsg)
          } else {
            //notification.Status(503, this)
          }
          this.evrakLoading = false;
        }).finally(() => {
          const findIndex = this.dekontListMain.findIndex(item => item.muhasebeID == row.muhasebeID)
          this.dekontListMain.splice(findIndex, 1)
          this.dekontForm.evrak = []
          this.dialogVisible = false
          this.updateTalimatID = null
        })
      }).catch((e) => {
        const findIndex = this.dekontListMain.findIndex(item => item.muhasebeID == row.muhasebeID)
        this.dekontListMain.splice(findIndex, 1)
        this.dekontForm.evrak = []
      })
    },
    evrakRemove() {
      $('#evrakEkle .el-upload--belge-card').show();
      this.dekontListMain = [];
      this.dekontForm.evrak = [];
    },
    downloadFile(item) {
      var downloadLink = document.createElement("a");
      downloadLink.href = talimatService.dekontPath + item.dekont;
      downloadLink.download = item.dekont;
      downloadLink.target = "_blank";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    talimetDetay(item = this.talimatData) {
      talimatService.talimatDetay(item.muhasebeID).then((response) => {
        localStorage.setItem("userDataDemirag", response.token)
        if (response.status == 200) {
          this.talimatData = response.data;
          this.dialogVisible = true
        }
      }).catch(err => {
        if (err.responseJSON) {
          let error = err.responseJSON
          if (error.status == 401) {
            notification.Status(150, this);
          } else if (error.status == 404) {
            this.talimatData = []
          } else notification.Status("errorMsg", this, error.errMsg)
        } else {
          //notification.Status(503, this)
        }
      })
    },
    checkDevice() {
      this.isDesktop = window.innerWidth >= 768;
    },
    updatePage(data) {
      talimatService.talimatDetay(data.muhasebeID).then((response) => {
        localStorage.setItem("userDataDemirag", response.token)
        if (response.status == 200) {
          this.$store.commit('setTalimatUpdateData', response.data)
          this.$store.commit('changeMusteriUpdateData', data.muhasebeID)
          functions.routeSayfa("Talimat Güncelle", this)
        }
      }).catch(err => {
        if (err.responseJSON) {
          let error = err.responseJSON
          if (error.status == 401) {
            notification.Status(150, this);
          } else if (error.status == 404) {
            this.talimatData = []
          } else notification.Status("errorMsg", this, error.errMsg)
        } else {
          //notification.Status(503, this)
        }
      })
    },
    talimatAra() {
      this.postPage = 0;
      this.page = 1
      this.dateVisible = false;
      //siparisNo, adSoyad, telefon, country, city, state, baslangicTarihi, bitisTarihi, durum, baslangic, limit,
      if (this.firmaAdiAra.length > 0 || this.unvanAra.length > 0 || this.adresAra.length > 0 || this.telefonAra.length > 0 || this.epostaAra.length > 0) {
        try {
          this.searchLoading = true;
          //kullaniciAdi, adSoyad, mail, telefon, durum, baslangic, limit)
          musteriService.musteriFilter(this.firmaAdiAra, this.unvanAra, this.adresAra, this.telefonAra, this.epostaAra, this.durum, this.postPage, this.sizes).then(response => {
            if (response.status == 200) {
              this.talimatList = response.data;
              this.total = response.count
            }
            localStorage.setItem("userDataDemirag", response.token);
            this.searchLoading = false;
          }).catch(err => {
            if (err.responseJSON) {
              let error = err.responseJSON
              if (error.status == 401) {
                notification.Status(150, this);
              } else if (error.status == 404) {
                this.talimatList = []
              }
            } else {
              //notification.Status(503, this)
            }
            this.searchLoading = false;
          })
        } catch (e) {
          // notification.Status("danger", this, "An error occurred during the customer search process.")
          this.searchLoading = false
        }
      } else {
        this.getTalimatListesi();
        // this.getMusteriSayisi();
      }
    },
    refreshPage(durum) {
      this.page = 1;
      this.postPage = 0;
      this.loading = false;
      this.stateLoading = false;

      // this.getMusteriSayisi();
      this.getTalimatListesi(durum);
    },
    vazgec(formName) {
      this.$refs[formName].resetFields();
      this.editDialog = false;
      this.loading = false;
      this.stateLoading = false;
    },
    changeTalimatDurum(selection, durum) {
      this.$confirm("Talimat durumunu güncellemek istediğinizden emin misiniz?", this.$t("src.views.apps.genel.uyari"), {
        confirmButtonText: this.$t("src.views.apps.genel.yes"),
        cancelButtonText: this.$t("src.views.apps.genel.no"),
        type: 'warning'
      }).then(() => {
        try {
          this.stateLoading = true;
          talimatService.talimatStatusUpdate(selection.muhasebeID, durum).then(response => {
            if (response.status == 200) {
              this.getTalimatListesi();
            }
            this.stateLoading = false;
            notification.Status("success", this, response.msg);
            localStorage.setItem("userDataDemirag", response.token);
          }).catch(err => {
            if (err.responseJSON) {
              let error = err.responseJSON
              if (error.status == 401) {
                notification.Status(150, this);
              } else notification.Status("errorMsg", this, error.errMsg)
            } else {
              //notification.Status(503, this)
            }
            this.stateLoading = false;
          })
        } catch (e) {
          // notification.Status("success", this, "An error occurred while fetching the customer number.");
          this.stateLoading = false;
        }
      })
    },
    getTalimatListesi(durum) {
      const logInYetkiler = this.$store.state.yetkiListesi;
      try {
        if (durum) this.durum = durum
        this.loading = true;
        talimatService.talimatListesi(this.durum, this.postPage, this.sizes).then((response) => {
          localStorage.setItem("userDataDemirag", response.token)
          if (response.status == 200) {
            this.talimatList = response.data;
            this.total = parseInt(response.toplamKayit);
          }
          this.loading = false;

        }).catch(err => {
          console.log(err);
          if (err.responseJSON) {
            let error = err.responseJSON
            if (error.status == 401) {
              notification.Status(150, this);
            } else if (error.status == 404) {
              this.talimatList = [];
            } else notification.Status("errorMsg", this, error.errMsg)
          } else {
            //notification.Status(503, this)
          }
          this.loading = false;
        })
      } catch (e) {
        // notification.Status("success", this, "An error occurred while fetching the customer list.")
        this.loading = false
      }
    },
    routeMusteri(name, scope) {
      if (scope) {
        this.$store.commit('changeMusteriUpdateData', scope);
      }
      functions.routeSayfa(name, this);
    },
    indexMethod(index) {
      return ((this.page - 1) * this.sizes) + index + 1;
    },
    handleSizeChange(val) {
      this.sizes = val;
      this.getTalimatListesi();
    },
    handleChange(event) {
      this.durum = event;
      this.page = 1;
      this.postPage = 0;
      this.getTalimatListesi();
      document.querySelector('.scrollable').scrollTo({top: 0, behavior: 'smooth'});
      this.firmaAdiAra = ""
      this.unvanAra = ""
      this.adresAra = ""
      this.telefonAra = ""
      this.epostaAra = ""
    },
    pageChange(val) {
      this.postPage = (val - 1) * this.sizes;
      this.getTalimatListesi();
    },
  }
}
</script>

<style lang="scss">
.el-table .info-row {
  background: rgba(125, 199, 225, 0.45);
}

.el-table .error-row {
  background: rgba(249, 0, 26, 0.08);
}

.el-table .success-row {
  background: rgba(3, 249, 0, 0.08);
}

.el-table .warning-row {
  background: rgba(245, 249, 0, 0.08);
}
</style>
<style lang="scss" scoped>
.upload-tooltip {
  width: 20% !important;
}

.upload-tooltip-modal {
  width: 6% !important;
}

.upload-btn {
  height: 40px !important;
  background-color: red;
  border: none;
}

.download-btn {
  height: 40px !important;
  background-color: #00A9FF;
  border: none;
}

.refresh {
  color: #fff;
  float: right;
  padding: 0 !important;
  transition: all 0.5s;

}

.refresh:hover {
  transform: rotate(360deg);
}

.el-pagination {
  margin-top: 20px;
  float: right;
}

.el-radio-button--mini .el-radio-button__inner label {
  position: relative;
  bottom: 5px;
}

.kaldirilmis {
  background: #ec205f;
  color: white;
  font-weight: bold;
  font-size: 16px;
  padding: 10px
}
</style>
<style lang="scss">
.slide-fade-enter-active {
  transition: all .3s ease;
}


@media (min-width: 768px) {
  .el-radio-button--mini .el-radio-button__inner {
    padding: 0 10px !important;
    font-size: 11px;
    border-radius: 0;
  }
}


.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,
.slide-fade-leave-to

  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(10px);
  opacity: 0;
}
</style>
<style>
/*
    .tablo{
        background-color: rgb(59, 123, 179); /*rgb(148, 197, 240);
    }*/

.tablo th.el-table__cell > .cell {
  background-color: aliceblue;
}


.islem-button {
  padding-top: 1px;
  padding-bottom: 1px;
  margin-top: 1px;
  margin-bottom: 1px;
  font-size: 0;
  line-height: 1;
  /* Butonun içeriği ile yükseklik arasındaki mesafeyi sıfırlar */
}

.buttonDel {
  padding-top: 1px;
  padding-bottom: 1px;
  margin-top: 1px;
  margin-bottom: 1px;
  font-size: 0;
  line-height: 1;
  /* Butonun içeriği ile yükseklik arasındaki mesafeyi sıfırlar */
}

.el-table .cell {
  line-height: 17px !important;
}

.el-table thead {
  line-height: 30px !important;
}
</style>